import React, { FC,  useEffect, useState } from 'react'
import styled from 'styled-components'

type LanguageType = 'de' | 'fr'
type StatusType = 'activated' | 'deactivated'
const Labels: { [k in LanguageType]: { [K in StatusType]: string } } = {
  de: { deactivated: 'Karte aktivieren', activated: 'Scrollen aktivieren' },
  fr: { deactivated: 'Karte aktivieren', activated: 'Scrollen aktivieren' },
}

export const InteractiveToggle = ({
  language = 'de',
  current = false,
  change,
  Visual,
}: {
  language?: 'de' | 'fr'
  current?: boolean
  change: (e: boolean) => void
  Visual?: FC<any>
}) => {
  const [isActive, setActive] = useState<true | false>(current)

  useEffect(() => {
    if (!change) return
    change(isActive === true ? true : false)
  }, [isActive])

  const Styled = Visual ? Visual : DefaultVisual
  return (
    <Styled
      isActive={isActive === true}
      onClick={() => {

        setActive(isActive === true ? false : true)
      }}
    >
        {Labels[language][isActive ? 'activated' : 'deactivated']}
    </Styled>
  )
}

const DefaultVisual = styled.button<{ isActive: boolean }>`
  position: absolute;
  padding: 0;
  pointer-events: all;
  transition: right 0.2s ease;
  right: ${({ isActive }) => (isActive ? '50px' : '10px')};
  top: 10px;
  z-index: ${({ isActive }) => (isActive ? 1202 : 0)};
  border: 0;

  @media only screen and (max-width: 711px) {
    right: ${({ isActive }) => (isActive ? '50px' : '0px')};
  }

  padding: 1rem 1.5rem;
  background-color: ${({ isActive }) =>
    isActive ? 'var(--red-main)' : 'var(--brandblue-main)'};
  color: #fff;
  font-family: var(--font-sans-serif);
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.2px;
  &:hover {
    cursor: pointer;
    background-color: ${({ isActive }) =>
      isActive ? 'var(--red-bright-1)' : 'var(--brandblue-bright-1)'};
  }
`
